// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"446fb9b4","455":"b05ebbb8"}[chunkId] + ".chunk.js";
};